import React from "react";
import Breadcrumb from "./Elements/Breadcrumb";
import ExampleSOPCard from "./Elements/ExampleSOPCard";
import SearchBadge from "./Elements/SearchBadge";
import sampleData from "./sampleData.json";
import SanityClient from "../../../utils/Sanity";
import groq from "groq";
import { useEffect } from "react";
import Footer from "../../Landing/Footer";
const ExampleUI = () => {
  const [data, setData] = React.useState<any>(null);

  useEffect(() => {
    SanityClient.fetch(groq`*[_type == "sop"]`).then((res) => {
      setData(res);
    });
  }, []);

  const tags = [
    "Business and Management",
    "Marketing",
    "Finance",
    "Human Resource Management",
    "Entrepreneurship",
    "Computer Science",
    "Data Science",
    "Computer Programming",
    "Information Security",
    "Artificial Intelligence",
    "Engineering",
    "Mechanical Engineering",
    "Electrical Engineering",
    "Civil Engineering",
    "Computer Engineering",
    "Social Sciences",
    "Economics",
    "Political Science",
    "Sociology",
    "Psychology",
    "Natural Sciences",
    "Biology",
    "Chemistry",
    "Physics",
    "Environmental Science",
    "Hotel Management",
    "Cinema",
    "Theatre",
    "Music",
    "Architecture",
    "Medicine",
    "Dentistry",
    "Pharmacy",
    "Nursing",
    "Law",
    "Accounting",
    "Journalism",
    "Public Relations",
    "Surgery",
    "Literature",
    "Philosophy",
    "Sociology",
    "History",
    "Linguistics",
    "Geography",
    "Hospitality and Tourism",
    "Agriculture",
    "Food Science",
    "Fashion Design",
    "Mass Communication",
    "Media Studies",
  ];
  const [selectedTag, setSelectedTag] = React.useState<string | null>(null);

  function handleSearch(tag: string) {
    if (selectedTag === tag) {
      setSelectedTag(null);
    } else {
      setSelectedTag(tag);
    }
  }

  return (
    <div>
      <div className="relative max-w-7xl mx-auto mt-10 grid sm:px-6 lg:px-4 px-4">
        {/* Header */}
        <div className="py-10 ">
          <Breadcrumb />
          <h1 className="text-4xl font-bold sm:text-5xl text-warm-gray-900 ">
            SOP Templates
          </h1>
          <p className="mt-4 max-w-4xl text-base sm:text-xl text-slate-500 line-clamp-3">
            Here are some examples of SOPs that have been created by our users.
            You can use these as a reference to create your own SOPs.
          </p>
        </div>

        <div className="flex gap-4 overflow-x-scroll py-2 mb-5 px-1 scrollbar-hide">
          <SearchBadge
            label="All"
            onClick={() => setSelectedTag(null)}
            selected={selectedTag === null}
          />

          {tags?.map((tag, key) => (
            <SearchBadge
              key={key}
              label={tag}
              onClick={(e) => handleSearch(e)}
              selected={selectedTag === tag}
            />
          ))}
        </div>
        {/* Cards */}
        <div className="mt-5 mb-10 grid grid-cols-1 justify-items-center gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {/* {sampleData.map((sop) => (
          <ExampleSOPCard title={sop.title} date={sop.date} tags={sop.tags} />
        ))} */}

          {data?.map((sop: any) => {
            if (selectedTag === null) {
              return (
                <ExampleSOPCard
                  key={sop._id}
                  id={sop._id}
                  title={sop.title}
                  date={sop._createdAt}
                  tags={sop.tags}
                />
              );
            } else {
              if (sop.tags.includes(selectedTag)) {
                return (
                  <ExampleSOPCard
                    key={sop._id}
                    id={sop._id}
                    title={sop.title}
                    date={sop._createdAt}
                    tags={sop.tags}
                  />
                );
              }
            }
          })}
        </div>
      </div>
      <div className="mt-8">
        <Footer />
      </div>
    </div>
  );
};
``;

export default ExampleUI;
